export default Object.freeze({
  'COMMENTS1': '약관/개인정보처리방침 관리',
  'COMMENTS2': '회사소개에 작성된 내용은 쇼핑몰 \'회사소개\' 영역에 보여집니다.',
  'COMMENTS3': '변경된 내용은 복구할 수 없으므로, 작성된 내용을 신중히 검토하신 후 저장해주세요.',
  'USED': '사용함',
  'NOT_USED': '사용 안 함',
  'EDITOR_INFO': '- 회사(쇼핑몰)을 소개하는 내용을 입력해주세요.',
  'SAVE_CHANGES': '변경사항 저장',
})